import { render, staticRenderFns } from "./LeadsStorage.vue?vue&type=template&id=0659c8ae&scoped=true"
import script from "./LeadsStorage.vue?vue&type=script&lang=js"
export * from "./LeadsStorage.vue?vue&type=script&lang=js"
import style0 from "./LeadsStorage.vue?vue&type=style&index=0&id=0659c8ae&prod&lang=css"
import style1 from "./LeadsStorage.vue?vue&type=style&index=1&id=0659c8ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0659c8ae",
  null
  
)

export default component.exports